<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3 d-none d-md-flex"></div>
        <div class="col-md-16 px-3 py-3">
          <div class="col d-column">
            <h1 class="title pt-2 mb-0" v-text="$ml.get('progClosTitle')"></h1>
            <h1 class="title">
              <span v-text="$ml.get('progClosSubTitle')" class="pb-2"></span>
            </h1>
            <div class="col-24 d-flex mb-3" style="z-index: 1000; gap: 10px">
              <div class="col-sm-8 my-3">
                <div class="input-group">
                  <input
                    class="form-control filterInput"
                    v-model="search"
                    :placeholder="$ml.get('titleProgram')"
                    aria-label="Search"
                    style="border-right: none"
                    @input="waitAPI"
                  />
                  <div class="input-group-append">
                    <div
                      class="input-group-text"
                      style="background-color: #fff"
                    >
                      <svg width="20" height="20" class="mt-1">
                        <image
                          xlink:href="../../../../src/assets/icons/search_s.svg"
                          width="18"
                          height="18"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div>
                  <p
                    class="time ml-1 m-0 mt-1"
                    v-text="
                      $ml
                        .with('results', ammountOfPages)
                        .with('totalResults', totalPages)
                        .get('showingResultsOfTotal')
                    "
                  >
                    Mostrando
                  </p>
                </div>
              </div>
            </div>
            <div class="card mb-3">
              <div class="card-body">
                <div class="d-column flex-row">
                  <div class="loading d-flex">
                    <div v-if="loading" class="c-loader"></div>
                    <h6
                      v-else
                      v-show="!listProgram.length"
                      class="p-1"
                      v-text="
                        $ml.get('youDontHaveAnyProgramsInThisCategoryYet')
                      "
                    >
                      Você ainda não possui programas nessa categoria
                    </h6>
                  </div>
                  <!-- <TimelineProgram :listProgram="listProgram" />  -->
                  <ListProgram :listProgram="listProgram" />
                </div>
              </div>
            </div>
            <div v-show="totalPages > 10 && !loading">
              <b-pagination
                v-model="pageActive"
                :total-rows="totalPages"
                :per-page="10"
                :prev-text="$ml.get('previous')"
                :next-text="$ml.get('next')"
                align="right"
              >
              </b-pagination>
            </div>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import ProgramService from "../../../services/program.service";
// import TimelineProgram from "../../../components/company/timelineProgram"
import _ from "lodash";
import ListProgram from "../../../components/ListProgram.vue";

export default {
  components: {
    ListProgram,
  },
  data() {
    return {
      title: "published",
      listProgram: [],
      loading: true,
      pageActive: 1,
      pageSize: 10,
      ammountOfPages: 0,
      totalPages: 1,
      search: "",
    };
  },
  watch: {
    pageActive() {
      this.changeProgram();
    },
  },
  mounted() {
    this.changeProgram();
  },
  methods: {
    waitAPI: _.debounce(function () {
      this.changeProgram();
    }, 500),

    nameFilter({ name }) {
      return `${this.$ml.get(name)}`;
    },
    changeProgram() {
      this.loading = true;
      ProgramService.getProgramInactive(
        this.pageActive,
        this.pageSize,
        this.search,
      ).then(
        (response) => {
          this.loading = false;
          this.listProgram = response.data.items;
          this.totalPages = response.data.total;

          if (this.listProgram) {
            if (this.listProgram.length == this.pageSize) {
              this.ammountOfPages = this.pageSize * this.pageActive;
            } else {
              this.ammountOfPages =
                this.pageSize * (this.pageActive - 1) +
                response.data.items.length;
            }
          }
        },
        () => {
          this.loading = false;
        },
      );
    },
  },
};
</script>
